module.exports = __webpack_public_path__ + "img/companylogo1.1adf4965.png";